<template>
  <div>
    <model-viewer
      v-if="authenticatedUserPasswordFile"
      style="width: 100%; height: 100vh; min-height: 100vh"
      :src="getImgUrl()"
      :ios-src="getIosUrl()"
      :skybox-image="getHdrUrl()"
      environment-image="neutral"
      auto-rotate
      autoplay
      camera-controls
      ar
      ar-modes="webxr scene-viewer quick-look"
      ar-scale="auto"
      alt="A 3D model of an astronaut"
    ></model-viewer>
    <v-overlay v-if="!authenticatedUserPasswordFile"
      ><v-card width="350" height="250" rounded="xl">
        <v-card-title class="justify-center" style="font-weight: 900"
          >augmentable</v-card-title
        >

        <v-form ref="form" class="pa-10">
          <v-text-field
            class="pb-0"
            v-model="shareFilePassword"
            outlined
            rounded="lg"
            label="Password"
            :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showEye = !showEye"
            :type="showEye ? 'text' : 'password'"
          ></v-text-field>
          <p class="mt-n5" style="color: red; text-align: left" v-if="error">
            {{ errorMsg }}
          </p>
          <v-row align="center" justify="center">
            <v-col cols="6"> </v-col>

            <v-col cols="4">
              <v-btn @click="checkPasswordConfirm()" size="10"> Verify </v-btn>
            </v-col>
            <v-col cols="2"></v-col>
          </v-row>
        </v-form> </v-card
    ></v-overlay>
  </div>
</template>

<script>
//Vue.component("htmlImport", htmlImport);

//import store from "../store";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

export default {
  name: "viewerAR",
  data: function () {
    return {
      sourc: "",
      sourcIOS: "",
      slug: this.$route.params.slug,
      authenticatedUserPasswordFile: false,

      //themeDark: false,

      shareFilePassword: "",
      pass: "",
      linkHDR: "",
      showEye: false,
      error: false,
      errorMsg: "",
    };
  },
  props: ["staticprop", "paramprop"],

  mounted() {
    axios
      .get(
        this.$abServerPath +
          "/api/glbfiles/augmentable/sharefile/" +
          this.slug +
          "/"
      )
      .then((response) => {
        this.sourc = this.$abServerPath + response.data.fileglb;
        this.sourcIOS = this.$abServerPath + response.data.fileusdz;
        this.pass = response.data.passwordShareFile;
        this.linkHDR = response.data.linkHDR;

        //console.log(response.data.passwordShareFile);

        //added for marketing lock/unlock resource
        this.authenticatedUserPasswordFile = !response.data.password_required;
      })
      .catch((error) => {
        console.log(error);
        //this.errored = true;
      });
  },
  // created() {
  //   axios
  //     .get(
  //       this.$abServerPath + "/api/glbfiles/augmentable/sharefile/" +
  //         this.slug +
  //         "/"
  //     ) //for local "/api/glb/glbgetallfile/"
  //     .then((response) => {
  //       this.sourc = "" + response.data.fileglb;
  //       this.sourcIOS = "" + response.data.fileusdz;
  //       this.pass = response.data.passwordShareFile;
  //       this.linkHDR = response.data.linkHDR;
  //       //console.log(response.data.passwordShareFile);

  //       //added for marketing lock/unlock resource
  //       this.authenticatedUserPasswordFile = !response.data.password_required;
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       //this.errored = true;
  //     });
  // },
  methods: {
    getImgUrl() {
      //console.log(store.state.viewerPath);
      //console.log(this.slug);
      return this.sourc;
      //return "/media/images/glbfiles/gjhj";
    },
    getIosUrl() {
      return this.sourcIOS;
    },
    getHdrUrl() {
      if (this.linkHDR !== null) {
        return this.linkHDR;
      } else {
        return (
          this.$abServerPath +
          "/media/images/hdrfiles/marketing_studio_augmentable_shamsail.hdr"
        );
      }
    },

    checkPasswordConfirm() {
      if (this.pass === this.shareFilePassword) {
        this.authenticatedUserPasswordFile = true;
        this.error = false;
        this.errorMsg = "";
      } else {
        this.error = true;
        this.errorMsg = "Wrong Password!";
        this.authenticatedUserPasswordFile = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>